export default {
  orange: '#f0ddcd',
  green: '#cfddbb',
  yellow: '#f2e9bb',
  gray1: '#222222',
  gray2: '#c4d4d5',
};
